import * as React from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RELEASE_VERSION } from '../releaseVersion';

export const ReleaseVersionNavItem = () => (
  <NavItem>
    <NavLink
      tag={Link}
      to="/release-notes"
      title={`View release notes for version ${RELEASE_VERSION}`}
      aria-label={`View release notes for version ${RELEASE_VERSION}`}
    >
      v{RELEASE_VERSION}
    </NavLink>
  </NavItem>
);
